module.exports = __webpack_public_path__ + "img/formnew.55fa75a2.png";